import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BaseNotableObjectConfigSchema,
  BlockType,
  ConsumerOfPatientOrderSchema,
  NotableObject,
} from '../base/baseSchema.js';

export const CreateEncounterConfigSchema = BaseNotableObjectConfigSchema.extend({
  notableObject: z.literal(NotableObject.Encounter),
  payload: z.string(),
});

export const CreatePatientConfigSchema = BaseNotableObjectConfigSchema.extend({
  notableObject: z.literal(NotableObject.Patient),
  payload: z.string(),
});

export const CreateServiceReviewSubmissionsConfigSchema = BaseNotableObjectConfigSchema.extend({
  notableObject: z.literal(NotableObject.ServiceReviewSubmissions),
  payload: z.string(),
  order: ConsumerOfPatientOrderSchema({ isRequired: true }),
});

export const CreateAuthorizationSubmissionsConfigSchema = BaseNotableObjectConfigSchema.extend({
  notableObject: z.literal(NotableObject.AuthorizationSubmissions),
  payload: z.string(),
  order: ConsumerOfPatientOrderSchema({ isRequired: true }),
});

export const CreateNotableObjectConfigSchema = z.discriminatedUnion('notableObject', [
  CreateEncounterConfigSchema,
  CreatePatientConfigSchema,
  CreateServiceReviewSubmissionsConfigSchema,
  CreateAuthorizationSubmissionsConfigSchema,
]);

export type CreateNotableObjectConfig = z.infer<typeof CreateNotableObjectConfigSchema>;

export const CreateNotableObjectBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.CreateNotableObject),
  config: CreateNotableObjectConfigSchema,
});

export type CreateNotableObjectBlock = z.infer<typeof CreateNotableObjectBlockSchema>;
